/**
 * 
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath"
import { MainRequest } from "@/core/request";

export default class AcademicTitleRequest extends MainRequest {

    static update(data) {
        return this.postSEC(ServicePath.ACADEMIC_TITLE_UPDATE_PROFILE, data);
    }
}